import localStorageService from "app/services/localStorageService";
import { incidentStatuses, INVESTIGATION_STATUS } from "./CONSTANTS";

export const getUserAccessRoles = () => {
  let auth_user = getAuthUser();
  let roles = {};
  roles = auth_user && auth_user.user ? auth_user.user.accessPermissions : {};
  return roles;
};

export const getLoggedInUserId = () => {
  let auth_user = getAuthUser();
  let id = "";
  id = auth_user && auth_user.user ? auth_user.user.id : {};
  return id;
};

export const getUserRolePermission = () => {
  let auth_user_permission = localStorageService.getItem("permissions");
  return auth_user_permission;
};

export const isUserRO = () => {
  // let permissions = getUserAccessRoles();
  // let result = false;
  // permissions &&
  //   permissions.map((role, index) => {
  //     if (
  //       role.permission === "reporterOfficer" &&
  //       role.permissionValue === "1"
  //     ) {
  //       result = true;
  //     }
  //   });
  // return result;
  let permission = getUserRolePermission();
  return permission?.reporterOfficer || false;
};

export const isUserSO = () => {
  let permission = getUserRolePermission();
  return permission?.safetyOfficer || false;
  // let permissions = getUserAccessRoles();
  // let result = false;
  // permissions.map((role, index) => {
  //   if (role.permission === "safetyOfficer" && role.permissionValue === "1") {
  //     result = true;
  //   }
  // });
  // return result;
};

export const isUserMM = () => {
  let permission = getUserRolePermission();
  return permission?.minesManager || false;
  // let permissions = getUserAccessRoles();
  // let result = false;
  // permissions.map((role, index) => {
  //   if (role.permission === "minesManager" && role.permissionValue === "1") {
  //     result = true;
  //   }
  // });
  // return result;
};

export const isSuperAdmin = () => {
  let permission = getUserRolePermission();
  return permission?.superAdmin || false;
};

export const isUserVFLOfficer = () => {
  let permission = getUserRolePermission();
  return permission?.vflOfficer || false;
  // let permissions = getUserAccessRoles();
  // let result = false;
  // permissions.map((role, index) => {
  //   if (role.permission === "vflOfficer" && role.permissionValue === "1") {
  //     result = true;
  //   }
  // });
  // return result;
};

export const IS_USER_SITE_HO = () => {
  const auth_user = getAuthUser();
  return +auth_user?.user?.employee?.ehsSite?.siteType === 1;
};

export const IS_USER_SITE_RO = () => {
  const auth_user = getAuthUser();
  return +auth_user?.user?.employee?.ehsSite?.siteType === 2;
};

export const IS_USER_SITE_MINES = () => {
  const auth_user = getAuthUser();
  return +auth_user?.user?.employee?.ehsSite?.siteType === 3;
};

export const LOGGED_IN_USER_SITE_ID = () => {
  const auth_user = getAuthUser();
  // console.log("/*/**/***/**/auth_user/*/", auth_user);
  return auth_user?.user?.employee?.ehsSite?.id || auth_user?.user?.siteId;
};

export const LOGGED_IN_USER_SITE_TYPE = () => {
  const auth_user = getAuthUser();
  return auth_user?.user?.employee?.ehsSite?.siteType;
};

export const LOGGED_IN_USER_EMPLOYEE_ID = () => {
  const auth_user = getAuthUser();
  return auth_user?.user?.employee?.id;
};

export const LOGGED_USER_ID = () => {
  return getAuthUser()?.user?.id;
};

export const LOGGED_USER_NAME = () => {
  const authUser = getAuthUser();
  return authUser?.user?.firstName + " " + authUser?.user?.lastName;
};

export const getReportAtLabelByStatus = (status) => {
  let nextRole = "ro";

  switch (status) {
    case "Draft":
      nextRole = "ro";
      break;
    case "Reported":
      nextRole = "so";
      break;
    case "Initial Review":
      nextRole = "mm";
      break;
    case "Investigation":
      nextRole = "so";
      break;
  }

  return nextRole;
};

export const getArraayofKeys = (inputObj) => {
  return Object.keys(inputObj);
};

export const checkStringsAreEqual = (stringA, stringB) => {
  let result = false;
  let stringOne = stringA.toLowerCase().replace(/\s/g, "");
  let stringTwo = stringB.toLowerCase().replace(/\s/g, "");

  if (stringOne === stringTwo) {
    result = true;
  }

  return result;
};

export const checkUserIsOfSameSite = (incidentSiteId) => {
  let result = false;
  const auth_user = getAuthUser();
  let userSiteId = auth_user?.user?.siteId;
  if (incidentSiteId === userSiteId) {
    result = true;
  }
  return result;
};

export const getAuthUser = () => {
  return localStorageService.getItem("auth_user");
};

export const getBackButtonText = (incident) => {
  let btnText = "Send Back";

  if (
    isUserSO() &&
    incident.severity > 3 &&
    incident?.investigationDetails?.investigationStatus ===
      INVESTIGATION_STATUS.completed &&
    incident?.reportAtLabel === "so"
  ) {
    btnText = "Send back to Investigation Officer";
  } else if (
    isUserSO() &&
    incident?.incidentStatus == incidentStatuses.open &&
    incident?.reportAtLabel === "so"
  ) {
    btnText = "Send back to Reporting Officer";
  } else if (
    isUserMM() &&
    incident.severity > 3 &&
    (incident?.incidentStatus === incidentStatuses.mmReview ||
      incident?.incidentStatus === incidentStatuses.investigationReviewed) &&
    incident?.reportAtLabel === "mm"
  ) {
    btnText = "Send back to Safety Officer";
  } else if (
    isUserMM() &&
    incident.severity > 3 &&
    incident?.incidentStatus == incidentStatuses.investigationReviewed
  ) {
    btnText = "Send back to Safety Officer";
  }

  return btnText;
};

export const getSubmitButtonText = (closeIncident = false, incident) => {
  let btnText = "Submit";
  if (
    incident?.reportAtLabel === "mm" &&
    isUserMM() &&
    incident?.severity > 3 &&
    incident?.investigationDetails?.investigationStatus ==
      INVESTIGATION_STATUS.completed &&
    incident?.incidentStatus !== incidentStatuses.capaReviewed
  ) {
    btnText = "Approve Investigation";
  } else if (
    incident?.reportAtLabel === "mm" &&
    isUserMM() &&
    incident?.severity > 3 &&
    incident?.incidentStatus === incidentStatuses.mmReview &&
    closeIncident
  ) {
    btnText = "Request Investigation";
  } else if (
    incident?.reportAtLabel === "mm" &&
    isUserMM() &&
    incident?.severity > 3 &&
    (incident?.incidentStatus === incidentStatuses.mmReview ||
      incident?.incidentStatus === incidentStatuses.capaReviewed)
  ) {
    btnText = "Close Incident";
  } else if (
    incident?.reportAtLabel === "so" &&
    isUserSO &&
    parseInt(incident?.severity) > 3 &&
    (incident?.incidentStatus == incidentStatuses.open ||
      incident?.incidentStatus == incidentStatuses.capaCompleted ||
      incident?.incidentStatus === incidentStatuses.investigationCompleted) &&
    incident?.reportAtLabel === "so"
  ) {
    btnText = "Submit to Mines Manager";
  } else if (
    incident?.reportAtLabel === "so" &&
    isUserSO() &&
    parseInt(incident?.severity) <= 3 &&
    incident?.reportAtLabel === "so"
  ) {
    if (incident?.incidentStatus == incidentStatuses.capaCompleted) {
      btnText = "Close Incident";
    } else {
      btnText = "Submit";
    }
  } else if (
    incident?.reportAtLabel === "so" &&
    isUserSO() &&
    parseInt(incident?.severity) > 3 &&
    incident?.reportAtLabel === "so"
  ) {
    btnText = "Close Incident";
  } else if (incident?.reportAtLabel === "so" && isUserRO() && !closeIncident) {
    btnText = "Submit to Safety Officer";
  } else if (closeIncident) {
    btnText = "Close Incident";
  }

  return btnText;
};

export const checkForRevertBackButton = (incident) => {
  let show = true;
  if (
    isUserSO() &&
    parseInt(incident?.severity) > 3 &&
    incident?.incidentStatus == incidentStatuses.capaCompleted &&
    incident?.reportAtLabel === "so"
  ) {
    show = false;
  } else if (
    isUserMM() &&
    parseInt(incident?.severity) > 3 &&
    incident?.incidentStatus == incidentStatuses.capaReviewed &&
    incident?.reportAtLabel === "mm"
  ) {
    show = false;
  } else if (
    isUserSO() &&
    parseInt(incident?.severity) < 4 &&
    incident?.incidentStatus == incidentStatuses.capaCompleted &&
    incident?.reportAtLabel === "so"
  ) {
    show = false;
  }
  return show;
};

export const isUserVTO = () => {
  let permissions = getUserRolePermission();
  if (permissions?.vto) {
    return true;
  } else {
    return false;
  }
};

export const isUserVFL = () => {
  let permissions = getUserRolePermission();
  if (permissions?.reporterOfficer) {
    return true;
  } else {
    return false;
  }
};

export const isUserRegionalManager = () => {
  let permissions = getUserRolePermission();
  if (permissions?.reporterOfficer) {
    return true;
  } else {
    return false;
  }
};

export const isUserManagingDirector = () => {
  let permissions = getUserRolePermission();
  if (permissions?.reporterOfficer) {
    return true;
  } else {
    return false;
  }
};

export const isUserDirectorOperations = () => {
  let permissions = getUserRolePermission();
  if (permissions?.reporterOfficer) {
    return true;
  } else {
    return false;
  }
};

export const isUserMeeting = () => {
  let permission = getUserRolePermission();
  if (permission?.reporterOfficer) {
    return true;
  } else {
    return false;
  }
};

export const isUserMedicalOfficer = () => {
  let permission = getUserRolePermission();
  return permission?.medicalOfficer || false;
};
export const isUserHeadSafetyOfficer = () => {
  let permission = getUserRolePermission();
  return permission?.headSafety || false;
};
export const isUserInvestigator = () => {
  let permission = getUserRolePermission();
  return permission?.investigator || false;
};
